import { Link } from 'react-router-dom';
import { MultiSelect } from 'primereact/multiselect';
import type { ColumnFilterElementTemplateOptions } from 'primereact/column';
import type { ColumnConfig } from '@/shared/ui/DataTable/DataTable';
import type { OrderCancellationRowResponse } from '@/core/generated/api';
import { formatDateTimeAtOffset } from '@/shared/lib/dateTime';
import { CANCELLATION_REASON_OPTIONS, CANCELLATION_INITIATOR_OPTIONS } from './options.config';

/** Выбирает несколько причин отмены */
const reasonFilter = (options: ColumnFilterElementTemplateOptions) => <MultiSelect
    aria-label="Причина отмены"
    value={options.value ?? []}
    options={CANCELLATION_REASON_OPTIONS}
    optionLabel="label"
    optionValue="value"
    onChange={event => options.filterApplyCallback(event.value)}
    placeholder="Все причины"
    display="chip"
    filter
    showClear
/>;

/** Выбирает нескольких инициаторов отмены */
const initiatorFilter = (options: ColumnFilterElementTemplateOptions) => <MultiSelect
    aria-label="Инициатор отмены"
    value={options.value ?? []}
    options={CANCELLATION_INITIATOR_OPTIONS}
    optionLabel="label"
    optionValue="value"
    onChange={event => options.filterApplyCallback(event.value)}
    placeholder="Все инициаторы"
    display="chip"
    showClear
/>;

/** Колонки административной таблицы отменённых заказов */
export const CANCELLATION_COLUMNS: ColumnConfig<OrderCancellationRowResponse>[] = [
    {
        field: 'orderNumber',
        filter: true,
        header: 'Заказ',
        sortable: true,
        body: row => <Link to={`/orders/${row.id}`}>{row.orderNumber}</Link>,
    },
    {
        field: 'reason',
        filter: true,
        header: 'Причина отмены',
        sortable: true,
        filterElement: reasonFilter,
        body: row => CANCELLATION_REASON_OPTIONS.find(option => option.value === row.reason)?.label ?? 'Не указана',
    },
    {
        field: 'description',
        filter: true,
        header: 'Описание отмены',
        body: row => row.description || '—',
    },
    {
        field: 'initiator',
        filter: true,
        header: 'Инициатор отмены',
        sortable: true,
        filterElement: initiatorFilter,
        body: row => CANCELLATION_INITIATOR_OPTIONS.find(option => option.value === row.initiator)?.label ?? 'Не определён',
    },
    {
        field: 'cancelledAt',
        header: 'Дата отмены',
        sortable: true,
        dataType: 'date',
        body: row => row.cancelledAt
            ? formatDateTimeAtOffset(row.cancelledAt, 180)
            : 'Не указана',
    },
];
